var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablePcheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,31H6a3,3,0,0,1-3-3V4A3,3,0,0,1,6,1H20a3,3,0,0,1,3,3V20",
    fill: "none",
    stroke: "#a805fb",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-color": "color-2",
    points: "19 27 22 30 29 23",
    fill: "none",
    stroke: "#a805fb",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "miter"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePcheck);
export default __webpack_public_path__ + "static/media/Table-Pcheck.5ae005f68427e279f1e162f576c4fd2f.svg";
export { ForwardRef as ReactComponent };